import React from "react";
import "../App.css";

const PrivacyPolicy = () => {
  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-12">
          <h1 className="text-center mb-5">Privacy Policy & Terms of Service</h1>
          
          <section className="mb-5">
            <h2>Terms & Conditions</h2>
            <p>
              These Terms & Conditions apply to the Vagabond app (hereby referred to as "Application") 
              for mobile devices that was created by Julie Barney (hereby referred to as "Service Provider") 
              as a Free service. This service is intended for use "AS IS".
            </p>
          </section>

          <section className="mb-5">
            <h2>Information Collection & Use</h2>
            <p>
              The Application collects information when you download and use it. This information may include information such as:
            </p>
            <ul>
              <li>Your device's Internet Protocol address (e.g. IP address)</li>
              <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
              <li>The time spent on the Application</li>
              <li>The operating system you use on your mobile device</li>
            </ul>
            <p>
              The Application collects your device's location, which helps the Service Provider determine your approximate 
              geographical location and make use of in the ways below:
            </p>
            <ul>
              <li>
                <strong>Geolocation Services:</strong> The Service Provider utilizes location data to provide features such as 
                personalized content, relevant recommendations, and location-based services.
              </li>
              <li>
                <strong>Analytics and Improvements:</strong> Aggregated and anonymized location data helps the Service Provider 
                to analyze user behavior, identify trends, and improve the overall performance and functionality of the Application.
              </li>
              <li>
                <strong>Third-Party Services:</strong> Periodically, the Service Provider may transmit anonymized location data 
                to external services. These services assist them in enhancing the Application and optimizing their offerings.
              </li>
            </ul>
            <p>
              The Service Provider may use the information you provided to contact you from time to time to provide you with 
              important information, required notices and marketing promotions.
            </p>
            <p>
              For a better experience, while using the Application, the Service Provider may require you to provide us with 
              certain personally identifiable information, including but not limited to:
            </p>
            <ul>
              <li>INTERNET</li>
              <li>ACCESS_FINE_LOCATION</li>
              <li>ACCESS_COARSE_LOCATION</li>
              <li>READ_EXTERNAL_STORAGE</li>
              <li>WRITE_EXTERNAL_STORAGE</li>
              <li>CAMERA</li>
            </ul>
            <p>
              The information that the Service Provider request will be retained by them and used as described in these terms and conditions.
            </p>
          </section>

          <section className="mb-5">
            <h2>Third Party Access</h2>
            <p>
              Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider 
              in improving the Application and their service. The Service Provider may share your information with third parties 
              in the ways that are described in this privacy statement.
            </p>
            <p>
              Please note that the Application utilizes third-party services that have their own Terms & Conditions about handling data. 
              Below are the links to the Terms & Conditions of the third-party service providers used by the Application:
            </p>
            <ul>
              <li>Google Play Services</li>
            </ul>
            <p>
              The Service Provider may disclose User Provided and Automatically Collected Information:
            </p>
            <ul>
              <li>as required by law, such as to comply with a subpoena, or similar legal process;</li>
              <li>
                when they believe in good faith that disclosure is necessary to protect their rights, protect your safety 
                or the safety of others, investigate fraud, or respond to a government request;
              </li>
              <li>
                with their trusted services providers who work on their behalf, do not have an independent use of the information 
                we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
              </li>
            </ul>
          </section>

          <section className="mb-5">
            <h2>Opt-Out Rights</h2>
            <p>
              You can stop all collection of information by the Application easily by uninstalling it. 
              You may use the standard uninstall processes as may be available as part of your mobile device 
              or via the mobile application marketplace or network.
            </p>
          </section>

          <section className="mb-5">
            <h2>Data-Retention Policy</h2>
            <p>
              The Service Provider will retain the data you have provided for as long as you use the Application 
              and for a reasonable time thereafter. If you'd like them to delete the data that you provided via the Application, 
              you can contact them at hello@thevagabondapp.com and they will respond in a reasonable time.
            </p>
          </section>

          <section className="mb-5">
            <h2>Children</h2>
            <p>
              The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
            </p>
            <p>
              The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect 
              personally identifiable information from children under 13 years of age. In the case the Service Provider 
              discover that a child under 13 has provided personal information, the Service Provider will immediately delete 
              this from their servers. If you are a parent or guardian and you are aware that your child has provided us with 
              personal information, please contact the Service Provider (hello@thevagabondapp.com) so that they will be able 
              to take the necessary actions.
            </p>
          </section>

          <section className="mb-5">
            <h2>Security</h2>
            <p>
              The Service Provider is concerned about safeguarding the confidentiality of your information. 
              The Service Provider provides physical, electronic, and procedural safeguards to protect information 
              the Service Provider processes and maintains.
            </p>
          </section>

          <section className="mb-5">
            <h2>Changes</h2>
            <p>
              This Terms & Conditions may be updated from time to time for any reason. The Service Provider will notify you 
              of any changes to the Terms & Conditions by updating this page with the new Terms & Conditions. 
              You are advised to consult this Terms & Conditions regularly for any changes, as continued use is deemed approval of all changes.
            </p>
            <p>
              These Terms & Conditions is effective as of 2024-09-13.
            </p>
          </section>

          <section className="mb-5">
            <h2>Your Consent</h2>
            <p>
              By using the Application, you are consenting to the processing of your information as set forth 
              in this Terms & Conditions now and as amended by us.
            </p>
          </section>

          <section className="mb-5">
            <h2>Contact Us</h2>
            <p>
              If you have any questions regarding privacy while using the Application, or have questions about the practices, 
              please contact the Service Provider via email at hello@thevagabondapp.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
